/**
 * Quality report (Chunk 9.R.2).
 *
 * Type + import statique littéral du rapport qualité courant. Phase 1 :
 *   - Rapport STATIQUE versionné dans `apps/web/src/generated/quality-report.json`.
 *   - Aucune exécution live de tests depuis le navigateur.
 *   - Aucun endpoint backend / shell / glob — un seul fichier autorisé, import
 *     littéral statique direct.
 *   - Pas de secrets : tous les champs `command` sont des invocations safe
 *     (pas d'env, pas de token, pas de JWT/API key/DB URL).
 *
 * Phase 2 future (si retour PO) :
 *   - Script local devops `apps/web/scripts/build-quality-report.mjs` qui collecte
 *     les vitest JSON reports + git rev-parse → met à jour ce JSON.
 *   - Pas d'exécution shell depuis le navigateur — strictement local/CI.
 *   - Bouton « Run all tests » Phase 2 = admin-only + job async contrôlé.
 */

import rawReport from "../generated/quality-report.json";

export type QualityStatus = "PASS" | "FAIL" | "UNKNOWN";

export type LegacyBudgetStatus = "STRICT" | "OK" | "FAIL";

export type QualityReport = {
  readonly generated_at: string;
  readonly branch: string;
  readonly commit: string;
  readonly commit_subject?: string;
  readonly covered_chunks?: ReadonlyArray<string>;
  readonly global_status: QualityStatus;
  readonly caveat?: string;
  readonly workspaces: ReadonlyArray<{
    readonly name: string;
    readonly build: QualityStatus;
    readonly typecheck: QualityStatus;
    readonly tests_total: number;
    readonly tests_passing: number;
    readonly targeted_tests?: number;
    readonly targeted_passing?: number;
    readonly tests_by_kind?: {
      readonly unit?: number;
      readonly integration?: number;
      readonly rtl?: number;
      readonly smoke?: number;
    };
    readonly notes?: string;
  }>;
  readonly legacy_budget?: {
    readonly stone_files: number;
    readonly font_display_files: number;
    readonly instrument_serif_files: number;
    readonly target_stone: number;
    readonly target_font_display: number;
    readonly target_instrument_serif: number;
    readonly status: LegacyBudgetStatus;
    readonly i18n_fr_en_parity?: string;
    readonly notes?: string;
  };
  readonly smoke_staging_recent?: ReadonlyArray<{
    readonly chunk: string;
    readonly date: string;
    readonly head_commit: string;
    readonly summary: string;
    readonly surfaces: ReadonlyArray<string>;
  }>;
  readonly ci_checks?: ReadonlyArray<{
    readonly name: string;
    readonly status: QualityStatus;
    readonly notes?: string;
  }>;
  readonly commands: ReadonlyArray<{
    readonly label: string;
    readonly command: string;
    readonly purpose?: string;
  }>;
  readonly phase1_safety?: {
    readonly live_test_execution_disabled: boolean;
    readonly admin_button_run_all_tests: string;
    readonly secrets_in_report: string;
    readonly report_source: string;
    readonly route_auth_gating: string;
  };
};

/**
 * Import littéral statique unique. Aucun chargement dynamique runtime, aucun
 * glob, aucun chemin paramétré.
 */
export const QUALITY_REPORT: QualityReport = rawReport as unknown as QualityReport;
